import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const SchedulesAPI = {
  getSchedules: async (token, queryParams = {}) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/schedules/`,
      headers: { Authorization: token },
      params: { ...queryParams },
    });
  },
  getSchedulesByGroup: async (token, scheduleGroupId) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/schedules/group/${scheduleGroupId}`,
      headers: { Authorization: token },
    });
  },
  getSchedulesByPreAuthorized: async (token, preAuthorizedId) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/schedules/pre-authorized/${preAuthorizedId}`,
      headers: { Authorization: token },
    });
  },
  createSchedule: async (token, data) => {
    return await axios({
      method: "POST",
      url: `${BACKEND_ORIGIN}/api/schedules`,
      headers: { Authorization: token },
      data,
    });
  },
  updateSchedule: async (token, data) => {
    return await axios({
      method: "PUT",
      url: `${BACKEND_ORIGIN}/api/schedules`,
      headers: { Authorization: token },
      data,
    });
  },
  deleteSchedule: async (token, id) => {
    return await axios({
      method: "DELETE",
      url: `${BACKEND_ORIGIN}/api/schedules/${id}`,
      headers: { Authorization: token },
    });
  },
};

export default SchedulesAPI;
